<span class={`badge ${type}`} class:rounded>
  <slot />
</span>

<script lang="ts">;
export let type = 'primary';
export let rounded = false;
</script>

<style>
.badge.rounded {
  border-radius: 30%;
}
</style>
